export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.27c9b77b.worker.js");
}
